export default __webpack_public_path__ + "static/media/low.3bc9cbad.jpg";